import React, { useState } from "react";
import { trackEvent } from "../analytics";
import { getUtmParams } from "../utils/utm";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [botField, setBotField] = useState("");
  const [status, setStatus] = useState("idle"); // idle | success | error
  const [error, setError] = useState("");

  function encode(data) {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (botField) {
      setStatus("success");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Enter a valid email address.");
      return;
    }
    setError("");

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": "newsletter",
        email,
        "bot-field": botField,
        ...getUtmParams(),
      }),
    })
      .then(() => {
        trackEvent("generate_lead", { form: "newsletter" });
        setStatus("success");
        setEmail("");
      })
      .catch(() => setStatus("error"));
  }

  if (status === "success") {
    return (
      <p className="text-sm text-purple-200">
        You're on the list. Thanks for subscribing.
      </p>
    );
  }

  return (
    <form
      name="newsletter"
      onSubmit={handleSubmit}
      className="flex flex-col sm:flex-row gap-2 max-w-sm"
    >
      <label htmlFor="newsletter-email" className="sr-only">
        Email address
      </label>
      <p className="hidden" aria-hidden="true">
        <label>
          Leave this field blank
          <input
            name="bot-field"
            tabIndex="-1"
            autoComplete="off"
            value={botField}
            onChange={(e) => setBotField(e.target.value)}
          />
        </label>
      </p>
      <input
        type="email"
        id="newsletter-email"
        name="email"
        placeholder="you@company.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-grow bg-purple-800 border border-purple-700 rounded-lg text-white placeholder-purple-300 py-2 px-4 text-sm focus:outline-none focus:border-purple-400"
        required
      />
      <button
        type="submit"
        className="text-white bg-purple-600 border-0 py-2 px-5 hover:bg-purple-500 rounded-lg text-sm font-medium whitespace-nowrap"
      >
        Subscribe
      </button>
      {error && <p className="text-red-300 text-xs">{error}</p>}
      {status === "error" && (
        <p className="text-red-300 text-xs">
          Something went wrong. Please try again.
        </p>
      )}
    </form>
  );
}
